import api from './api';
import { ProductoFoto } from '../utils/productImage';

export interface Producto {
    codigoArticulo: string;
    descripcion: string;
    costo?: number;
    /** Precio neto (sin IVA), mapea a Stock.PrecioSinIva en la API. */
    precioVenta?: number;
    imagen?: string | null;
    fotos?: ProductoFoto[];
    // otros campos que pueda tener el producto
}

export interface ProductoSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

interface ProductoPagedResult {
    items: Producto[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

interface ProductoBulkError {
    indice: number;
    codigoArticulo: string;
    mensaje: string;
}

interface ProductoBulkResult {
    exitosos: number;
    fallidos: number;
    errores: ProductoBulkError[];
}

interface UploadProductoFotoInput {
    archivo: File;
    esPrincipal?: boolean;
}

const productoService = {
    getProducto: async (codigoArticulo: string): Promise<Producto> => {
        const response = await api.get<Producto>(`/api/productos/${codigoArticulo}`);
        return response.data;
    },
    actualizarCantidad: async (codigoArticulo: string, cantidad: number, tipoAjuste: string, nroUbicacionOrigen?: number, nroUbicacionDestino?: number) => {
        const response = await api.put(`/api/productos/actualizarCantidad`, {
            codigoArticulo,
            cantidad,
            tipoAjuste,
            nroUbicacionOrigen,
            nroUbicacionDestino
        });
        return response.data;
    },
    getProductos: async (params: ProductoSearchParams): Promise<ProductoPagedResult> => {
        const response = await api.get<ProductoPagedResult>('/api/Productos', { params });
        return response.data;
    },
    createProducto: async (producto: Producto) => {
        const response = await api.post('/api/productos', producto);
        return response.data;
    },
    createProductosBulk: async (productos: any[]): Promise<ProductoBulkResult> => {
        const response = await api.post<ProductoBulkResult>('/api/Productos/Bulk', productos);
        return response.data;
    },
    getFotos: async (codigoArticulo: string): Promise<ProductoFoto[]> => {
        const response = await api.get<ProductoFoto[]>(`/api/productos/${codigoArticulo}/fotos`);
        return response.data ?? [];
    },
    uploadFoto: async (codigoArticulo: string, input: UploadProductoFotoInput): Promise<ProductoFoto> => {
        const formData = new FormData();
        formData.append('archivo', input.archivo);
        if (typeof input.esPrincipal === 'boolean') {
            formData.append('esPrincipal', String(input.esPrincipal));
        }

        const response = await api.post<ProductoFoto>(`/api/productos/${codigoArticulo}/fotos`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },
    setFotoPrincipal: async (codigoArticulo: string, fotoId: number) => {
        await api.put(`/api/productos/${codigoArticulo}/fotos/${fotoId}/principal`);
    },
    deleteFoto: async (codigoArticulo: string, fotoId: number) => {
        await api.delete(`/api/productos/${codigoArticulo}/fotos/${fotoId}`);
    },
};

export default productoService; 